import { useState } from 'react'
import { Image } from 'src/shared/components/ui'
import { cn } from 'src/shared/components/ui/utils'

export const IconImage = ({ src, selected, onClick, className }) => {
  const [imageError, setImageError] = useState(false)

  const handleImageError = () => {
    setImageError(true)
  }

  if (imageError) {
    return null
  }

  return (
    <div
      className={cn(
        'bg-slate-200 p-2 rounded-md border-2 border-white',
        'flex items-center justify-center w-auto overflow-hidden cursor-pointer',
        selected && 'border-blue-500',
        className
      )}
      onClick={onClick}
    >
      <Image
        src={src}
        className="object-contain rounded-md w-full h-full"
        onError={handleImageError}
      />
    </div>
  )
}
